import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'ap-southeast-2_IlN1ijr5i',
      userPoolClientId: '1o1jfgquhv5k1mu1voqebhscei',
      loginWith: {
        oauth: {
          domain: 'auth.redspeed.com.au',
          scopes: ['email', 'profile', 'openid'],
          redirectSignIn: [
            'http://localhost:3000/',
            'https://gapgo.redspeed.com.au/',
            'https://d4gu11pce3k81.cloudfront.net/',
          ],
          redirectSignOut: [
            'http://localhost:3000/',
            'https://gapgo.redspeed.com.au/',
            'https://d4gu11pce3k81.cloudfront.net/',
          ],
          responseType: 'code',
        },
      },
    },
  },
});
